export default class Command {
    constructor(item) {
        this.id = item != null ? item.id : '';
        this.name = item != null ? item.name : '';
        this.priceAgreementType = item != null ? item.priceAgreementType : 0
        this.price = item != null ? item.price : 0;
        this.agreementPrice = item != null ? item.agreementPrice : 0;
        this.startdate = item != null ? item.startdate : '';
        this.enddate = item != null ? item.enddate : '';
        this.isVariable = item != null ? item.isVariable : false;
        this.invoiceType = item != null ? item.invoiceType : 0;
        this.cycleInMonths = item != null ? item.cycleInMonths : 1;
    }
}